/**
 * Secrets (encrypted vault) event types for durable event recording (SEC-1/2).
 */
export enum SecretsEventType {
  VAULT_CREATED = 'secrets:vault-created',
  VAULT_UPDATED = 'secrets:vault-updated',
  VAULT_DELETED = 'secrets:vault-deleted',
  /** Durable audit event emitted on every decrypted read (never carries the value). */
  VAULT_READ = 'secrets:vault-read',
}

/**
 * Pub/sub channel for secrets events.
 */
export const SECRETS_EVENTS_CHANNEL = 'secrets:events';